export default __webpack_public_path__ + "logo-google-play-fr-953c72da2865ea6bd4b9ebcd55598fb2.svg";